(function() { window.GUID_1de22f65_1b5d_4ee3_ab55_90fa1ff28613 = { getGuid: function() { return "1de22f65-1b5d-4ee3-ab55-90fa1ff28613"; } }; })();
var Register;
(function (Register) {
    let firstName = $('#FirstName');
    let lastName = $('#LastName');
    let email = $('#Email');
    let password = $('#Password');
    let newPassword = $('#NewPassword');
    let confirmPassword = $('#ConfirmPassword');
    let timerPassword = null;
    let passwordValidationResult = $('#PasswordValidationResult');
    firstName.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    lastName.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    email.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    password.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    newPassword.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    confirmPassword.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    function PreValidatePasswordStrenght() {
        if (password.length == 0 || password.val().length == 0) {
            return;
        }
        if (timerPassword != null) {
            clearTimeout(timerPassword);
        }
        timerPassword = setTimeout(function () {
            let data = {
                firstName: firstName.val(),
                lastName: lastName.val(),
                email: email.val(),
                password: password.val(),
                confirmPassword: confirmPassword.val()
            };
            CompuSport.Ajax.Get(CSParameters.RUrl + "Account/PreValidatePasswordStrength/0", data, function (queryResult) {
                passwordValidationResult.html(queryResult);
            });
        }, 500);
    }
})(Register || (Register = {}));

//# sourceMappingURL=Register.js.map
